import { WidthConstraint } from "@faire/web-api--source/indigofair/data/WidthConstraint";
export var getWidthConstraintCSS = function(widthConstraint) {
    switch(widthConstraint){
        case WidthConstraint.FULL_WIDTH:
            return "100%";
        case WidthConstraint.THREE_QUARTERS_WIDTH:
            return "75%";
        case WidthConstraint.TWO_THIRDS_WIDTH:
            return "66%";
        default:
            return undefined;
    }
};
